import { OpenOptions } from "../hooks/useSimplePopup";

export const DELAY_MINIMUM_CLOSE_TIME = 500;
export const DELAY_MINIMUM_OPEN_TIME = 300;

export const isArrayEmpty = (array?: any[]) => {
  if ((array?.length ?? 0) === 0) {
    return true;
  } else {
    return false;
  }
};

export const errorResponse = (
  e: any,
  open: (message: string, option?: OpenOptions) => void,
  message: string
) => {
  if (e?.response?.data?.error) {
    open(e?.response?.data?.error.replace(". ", ".\n"));
  } else {
    open(message);
  }
};

export const getBase64FileList = async (
  base64StringList: string[],
  filename: string
) => {
  return Promise.all(
    base64StringList.map(async (base64String) => {
      if (base64String === "") return "";
      return base64ToFile(base64String, filename);
    })
  );
};

export const base64ToFile = async (base64String: string, filename: string) => {
  const byteString = window.atob(base64String.split(",")[1]);
  const mimeString = base64String.split(",")[0].split(":")[1].split(";")[0];
  const fileExt = mimeString.split("/")[1];
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uint8Array = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteString.length; i++) {
    uint8Array[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([arrayBuffer], { type: mimeString });

  // Blob 객체를 File 객체로 변환
  const file = new File([blob], filename + "." + fileExt, {
    type: mimeString,
  });

  // resize를 native에서 처리함으로 resizeAndRotateImage 함수를 사용하지 않음
  return file;
};

export const cutNameForView = (name: string, cutLength: number): string => {
  if (name.length > cutLength) {
    return name.slice(0, cutLength) + "...";
  }
  return name;
};

export const maskingName = (name?: string) => {
  if (!name) return "";

  const hasKorean = /[가-힣]/.test(name);
  const words = hasKorean ? [name.split(" ").join("")] : name.split(" ");

  return words
    .map((word) => {
      if (word.length <= 2) {
        return word[0] + "*";
      } else {
        if (hasKorean) {
          return word[0] + "*".repeat(word.length - 2) + word[word.length - 1];
        } else {
          return word[0] + word[1] + "*".repeat(word.length - 2);
        }
      }
    })
    .join(" ");
};

export const isNumber = (value: any): value is number => {
  return typeof value === "number";
}
